export default __webpack_public_path__ + "static/media/fundallocation.b290e455.png";